class ScriptHelper {

  public static getScriptElement = () => {
    return document.querySelectorAll('[data-ws-domain-id]')?.item(0);
  }

}

export default ScriptHelper;

